import { render, staticRenderFns } from "./AddAppointmentTypePage.vue?vue&type=template&id=2f7a2362"
import script from "./AddAppointmentTypePage.vue?vue&type=script&lang=ts"
export * from "./AddAppointmentTypePage.vue?vue&type=script&lang=ts"
import style0 from "./AddAppointmentTypePage.vue?vue&type=style&index=0&id=2f7a2362&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports